import React from 'react';
import PropTypes from 'prop-types';
import styles from './GridItemStyles';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const GridItem = props => {
    const { classes, children, className, ...rest } = props;
    return (
        <Grid item {...rest} className={classes.grid + ' ' + className}>
            {children}
        </Grid>
    );
};

GridItem.defaultProps = {
    className: ''
};

GridItem.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

export default withStyles(styles)(GridItem);
